var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:telegram-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5991 4.61748C20.8566 4.50913 21.1383 4.47177 21.4151 4.50927C21.6918 4.54676 21.9535 4.65776 22.1728 4.83069C22.3921 5.00362 22.561 5.23218 22.662 5.49256C22.763 5.75295 22.7924 6.03564 22.7471 6.31123L20.3846 20.6414C20.1554 22.0237 18.6387 22.8164 17.371 22.1279C16.3106 21.5519 14.7356 20.6644 13.3189 19.7383C12.6106 19.2748 10.4408 17.7904 10.7075 16.7341C10.9366 15.831 14.5825 12.4373 16.6658 10.4196C17.4835 9.62685 17.1106 9.16956 16.145 9.89873C13.7471 11.7091 9.89705 14.4623 8.62414 15.2373C7.50122 15.9206 6.9158 16.0373 6.2158 15.9206C4.93872 15.7081 3.75434 15.3789 2.78768 14.9779C1.48143 14.4362 1.54497 12.6404 2.78663 12.1175L20.5991 4.61748Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/Telegram-icon.6fd9972045d7bd9b8e5b3026b1730cae.svg";
export { ForwardRef as ReactComponent };